import { useSelector } from "react-redux";

function Header() {

  const version = useSelector((state) => state.mainMode.version);

  return (
    <div className="header">
      <span className="title">HCL Haxball Replay Analyzer v{version}</span>
      <a href="http://blog.haxball.com" target="_blank" rel='noreferrer'>News</a>
      <a href="https://www.haxball.com/play" className="active" target="_blank" rel='noreferrer'>Play</a>
      <a href="https://www.haxball.com/community" target="_blank" rel='noreferrer'>Community</a>
      <a href="https://discord.gg/CZhxg9E" target="_blank" rel='noreferrer'>Discord</a>
      <a href="/haxballdownload" target="_blank" rel='noreferrer'>Haxball App Download</a>
    </div >
  );
}

export default Header;